import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import "./CreateGroupModal.css";
import apiClient from "./../../api/apiClient";
import { toast } from "react-toastify";

const AttachFilesModal = ({
  show,
  handleClose,
  nodeOptions,
  handleFilesAttached,
  groupName,
  selectedNode,
  setSelectedNode,
  attachedFiles,
  attachmentNode,
  setAttachedFiles,
  setAttachmentNode,
}) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const [isUploading, setIsUploading] = useState(false); // Loader state

  const handleNodeChange = (event) => {
    setSelectedNode(event.target.value);
    setAttachmentNode(event.target.value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Select first file if present
    if (file) {
      if (attachedFiles[selectedNode]) {
        // Check if file already attached to the selected node
        toast.error("Only one file can be attached per node.");
        return;
      }
      setFiles([file]);
    }
  };

  const handleAttach = async () => {
    if (!selectedNode) {
      toast.error("Please select a node.");
      return;
    }
    if (!files || files.length === 0) {
      toast.error("Please select a file to attach.");
      return;
    }

    setIsUploading(true); // Start loader

    try {
      const file = files[0];
      // const fileName = file.name.replace(/\s+/g, "_").replace(/[()]/g, "");

      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("size", file.size);
      formData.append("type", file.type);
      formData.append("file", file);
      formData.append("groupname", groupName);

      const response = await apiClient.post("/document/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        handleFilesAttached(files);
        setAttachedFiles((prev) => ({
          ...prev,
          [selectedNode]: file.name, // Store fileName
        }));

        toast.success("File uploaded successfully.");
        setFiles([]);
        setAttachmentNode("");
        handleClose();
      } else {
        toast.error("File upload failed. Please try again.");
      }
    } catch (error) {
      toast.error(
        error.response.data.error || "File upload failed. Please try again."
      );
      console.error("File upload error:", error);
    } finally {
      setIsUploading(false); // Stop loader
    }
  };

  const handleCloseModal = () => {
    setSelectedNode(""); // Reset selected node
    setAttachmentNode(""); // Reset attachment node
    setFiles([]); // Clear files
    handleClose(); // Call parent handler
  };

  return (
    <Modal show={show} onHide={handleCloseModal} className="attach-files-modal">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>
          Upload Attachment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="attach-files-content">
          <div className="form-group">
            <label htmlFor="selectNode">Select Node</label>
            <select
              id="selectNode"
              className="form-control"
              value={attachmentNode}
              onChange={handleNodeChange}
            >
              <option value="" disabled>
                -- Select a Node --
              </option>
              {nodeOptions.map((node, index) => (
                <option
                  key={index}
                  value={node}
                  disabled={attachedFiles[node]} // Disable if node has a file
                >
                  {" "}
                  {node}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group mt-3">
            <label htmlFor="fileUpload">Attach Files</label>
            <input
              type="file"
              multiple={false}
              id="fileUpload"
              className="form-control"
              onChange={handleFileChange}
              disabled={!selectedNode} // Disable if no node selected
            />
          </div>

          {error && <div className="text-danger mt-2">{error}</div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          className="create-button"
          onClick={handleAttach}
        >
          {isUploading ? (
            <>
              <Spinner animation="border" size="sm" />
              <span> Uploading...</span>
            </>
          ) : (
            "Upload File"
          )}
        </Button>
        <Button
          variant="secondary"
          className="cance-button"
          onClick={() => {
            handleClose();
            setSelectedNode("");
            setFiles([]);
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AttachFilesModal;
